import { Model, modelRegistry } from './Model';
import { Product, ProductCategory } from '../models';
import { HashGen } from '../utilities';
import moment from 'moment-timezone';
export class KitchenTicketItem extends Model {
    static entity = 'kitchen_tickets';
    static primaryKey = 'hash';
    id = null;
    hash = '';
    kitchen_ticket_id = null;
    kitchen_ticket_hash = '';
    order_item_id = null;
    order_item_hash = '';
    product_id = null;
    name = '';
    count = '1.000';
    comments = [];
    completed_at = null;
    created_at = null;
    updated_at = null;
    static fields() {
        return {
            id: this.attr(null),
            hash: this.attr(HashGen.long()),
            kitchen_ticket_id: this.attr(null),
            kitchen_ticket_hash: this.attr(''),
            order_item_id: this.attr(null),
            order_item_hash: this.attr(''),
            product_id: this.attr(null),
            name: this.attr(''),
            count: this.attr('1.000', value => this.round(value, 3).toFixed(3)),
            comments: this.attr([]),
            completed_at: this.attr(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
        };
    }
    constructor(record) {
        super();
        this.$fill(record);
    }
    complete(complete = true) {
        if (!complete) {
            this.completed_at = null;
            return;
        }
        this.completed_at = moment().utc().format(KitchenTicketItem.DATE_FORMAT);
    }
    getProduct() {
        return Product.find(this.product_id);
    }
    getCategory() {
        const product = Product.find(this.product_id);
        if (!product)
            return undefined;
        return ProductCategory.find(product.category_id);
    }
}
export default KitchenTicketItem;
modelRegistry.register('KitchenTicketItem', KitchenTicketItem);
//# sourceMappingURL=KitchenTicketItem.js.map